export default {
  render(h) {
    return (
      <footer class="bg-accent border-t-4 border-gray-700">
        <div class="container mx-auto px-3 lg:px-6 py-10">
          
        </div>
      </footer>
    )
  },
};
